import React from "react";
import {Card} from 'react-bootstrap';

function STCCardBody(props){

    return(
        <Card.Body
            style={props.style}
            className={props.className}

            as={props.as}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Card.Body>
    )

}
export default STCCardBody